var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ParagraphBody',[_vm._v(" Test Device Management with policies. ")]),_c('ButtonSecondary',{attrs:{"data-test-id":_vm.$testId('addButton'),"text":"Add"},on:{"click":_vm.addFeature}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }